export default "__VITE_ASSET__D05Udk13__"